var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('h2',[_vm._v("\n    "+_vm._s(_vm.position)+"\n  ")]),_c('p',[_vm._v(_vm._s(_vm.copy))]),_c('p',{staticClass:"op1"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("\n      Join us →\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }